/**
 * Report service — post reports use feedService.reportPost (live).
 * User reports stay gated until a dedicated backend endpoint exists.
 */

/** Flip when a real ReportUser (or equivalent) API is available. */
export const USER_REPORT_API_ENABLED = false;

export interface ReportReason {
  id: number;
  /** i18n key under profile.report.options.* */
  labelKey: string;
}

export interface ReportUserPayload {
  reportedUserId: number;
  reportReasonIds: number[];
  otherReason?: string;
}

/** Shared reason catalog — IDs align with ReportPost reasonId for posts. */
export const REPORT_REASON_OPTIONS: ReportReason[] = [
  { id: 1, labelKey: 'profile.report.options.spam' },
  { id: 2, labelKey: 'profile.report.options.dontLikeIt' },
  { id: 3, labelKey: 'profile.report.options.bullying' },
  { id: 4, labelKey: 'profile.report.options.suicide' },
  { id: 5, labelKey: 'profile.report.options.violence' },
  { id: 6, labelKey: 'profile.report.options.restrictedItems' },
  { id: 7, labelKey: 'profile.report.options.nudity' },
  { id: 8, labelKey: 'profile.report.options.scam' },
  { id: 9, labelKey: 'profile.report.options.falseInfo' },
  { id: 10, labelKey: 'profile.report.options.other' },
];

export const OTHER_REPORT_REASON_ID = 10;

export const reportService = {
  /**
   * Local reason catalog until a reasons API exists.
   * Labels are i18n keys — translate in the UI with t(reason.labelKey).
   */
  getReportReasons: async (): Promise<ReportReason[]> => REPORT_REASON_OPTIONS,

  /**
   * Submits a report against a user.
   * Returns failure while USER_REPORT_API_ENABLED is false — never fake success.
   * `message` is an i18n key when present.
   */
  reportUser: async (
    _payload: ReportUserPayload,
  ): Promise<{ success: boolean; message?: string }> => {
    if (!USER_REPORT_API_ENABLED) {
      return {
        success: false,
        message: 'profile.report.errors.userReportUnavailable',
      };
    }

    // TODO: wire to real ReportUser endpoint when available.
    return {
      success: false,
      message: 'profile.report.errors.userReportUnavailable',
    };
  },
};

export default reportService;
